import { render, staticRenderFns } from "./SSelectForeman.vue?vue&type=template&id=6d9b32ca"
import script from "./SSelectForeman.vue?vue&type=script&lang=js"
export * from "./SSelectForeman.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports